import { render } from "./ShopToys.vue?vue&type=template&id=020bbfdb"
import script from "./ShopToys.vue?vue&type=script&lang=js"
export * from "./ShopToys.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__